module.exports = __webpack_public_path__ + "static/img/Matt-Burton.3338ab0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Burton.jpg
// module id = NlvG
// module chunks = 0